import {createAction} from 'redux-actions'

export const update = createAction('UPGRADE_STATUS/STORE/UPDATE', rows => Array.isArray(rows) ? rows : [rows])
export const retry = createAction('UPGRADE_STATUS/STORE/RETRY', ids => Array.isArray(ids) ? ids : [ids])
export const purge = createAction('UPGRADE_STATUS/STORE/PURGE')
export const setUpagradeStatusPackagesLoading = createAction(
    'UPGRADE_STATUS/STORE/SET_PACKAGES_LOADING'
)